import Api from './'

const tags = {

	/**
	 * Get a list of casts.
	 */
	list(params={})
	{
		let url = Api.getUrl(`tags`)

		return Api.client().get(url, { params })
	},

	/**
	 * Get one cast details.
	 */
	one(slug, params={})
	{
		let url = Api.getUrl(`tag/${slug}`)

		return Api.client().get(url, { params })
	},

}

export default tags